/**
파일명: MainLayout.jsx
설명: 헤더/본문/푸터 공통 프레임을 구성하는 레이아웃 컴포넌트입니다.
*/

import Footer from '../components/common/Footer';
import Header from '../components/common/Header';

export default function MainLayout({ pathname, onNavigate, children }) {
  // [비즈니스] 모든 페이지에서 동일한 브랜드 프레임을 유지해 UX 일관성을 확보합니다.
  // [기능] 헤더와 푸터를 고정 배치하고 중앙 본문에 페이지 콘텐츠(children)를 렌더링합니다.
  // [기술] 단순 조합형 레이아웃으로 페이지 컴포넌트의 중복 마크업을 제거합니다.
  return (
    <div className="site-shell">
      <Header pathname={pathname} onNavigate={onNavigate} />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
